module.exports = __webpack_public_path__ + "img/logo.f8f1a14f.png";